import React from 'react';
import { LightbulbIcon, TrendingUpIcon, TrendingDownIcon, AlertCircleIcon } from 'lucide-react';
interface Insight {
  id: number;
  text: string;
  type: 'positive' | 'negative' | 'warning' | 'neutral';
}
interface BIInsightsProps {
  insights: Insight[];
}
export function BIInsights({
  insights
}: BIInsightsProps) {
  const getIcon = (type: string) => {
    switch (type) {
      case 'positive':
        return <TrendingUpIcon size={16} className="text-emerald-400" data-id="element-657" />;
      case 'negative':
        return <TrendingDownIcon size={16} className="text-red-400" data-id="element-658" />;
      case 'warning':
        return <AlertCircleIcon size={16} className="text-amber-400" data-id="element-659" />;
      default:
        return <LightbulbIcon size={16} className="text-blue-400" data-id="element-660" />;
    }
  };
  const getBg = (type: string) => {
    switch (type) {
      case 'positive':
        return 'bg-emerald-500/10 border-emerald-500/20';
      case 'negative':
        return 'bg-red-500/10 border-red-500/20';
      case 'warning':
        return 'bg-amber-500/10 border-amber-500/20';
      default:
        return 'bg-blue-500/10 border-blue-500/20';
    }
  };
  return <div className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-sm rounded-xl border border-white/10 p-5" data-id="element-661">
      <div className="flex items-center mb-4 pb-3 border-b border-white/10" data-id="element-662">
        <LightbulbIcon size={18} className="text-amber-400 mr-2" data-id="element-663" />
        <h3 className="text-white font-semibold text-sm" data-id="element-664">Automated Insights</h3>
      </div>

      <div className="space-y-3" data-id="element-665">
        {insights.map(insight => <div key={insight.id} className={`flex items-start p-3 rounded-lg border ${getBg(insight.type)}`} data-id="element-666">
            <div className="mt-0.5 mr-3 flex-shrink-0" data-id="element-667">
              {getIcon(insight.type)}
            </div>
            <p className="text-sm text-blue-100 leading-relaxed" data-id="element-668">
              {insight.text}
            </p>
          </div>)}
      </div>
    </div>;
}